import { httpsCallable } from "firebase/functions";

import { cloudFunctions } from "./getFunctions";
import {
  VerificarCodigoPromocional,
  CloudFunctionResponseVerificarCodigoPromocional,
  CallablesGeneral
} from "@fixeduy/restaurantestypes";

const verificarCodigoPromocional = async (
  data: VerificarCodigoPromocional
): Promise<CloudFunctionResponseVerificarCodigoPromocional> => {
  const run = httpsCallable<
    CallablesGeneral,
    CloudFunctionResponseVerificarCodigoPromocional
  >(cloudFunctions, "callablesGenerales");
  const result = await run({
    func: "verificarCodigoPromocional",
    params: data
  });
  return result.data;
};

export { verificarCodigoPromocional };
